import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../reducers/rootReducer';

// Use "globalThis" instead of "window", "self", or "global" (javascript:S7764)
const window = globalThis.window;
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// eslint-disable-next-line no-underscore-dangle
const preloadedState = window.__data || {};
const store = createStore(rootReducer, preloadedState, composeEnhancers(applyMiddleware(thunk)));

export default store;
